import { useEffect } from 'react';
export const useClickOutsideOverflow = ({ openSubMenu, setOpenSubMenu, menuButton, profileButton, wrapperRef, }) => {
    useEffect(() => {
        const isDesktop = window.document.body.clientWidth > 840;
        const handleMouseLeave = (event) => {
            var _a;
            const target = event.target;
            if (openSubMenu &&
                !((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !(menuButton === null || menuButton === void 0 ? void 0 : menuButton.contains(target)) &&
                !(profileButton === null || profileButton === void 0 ? void 0 : profileButton.contains(target)) &&
                isDesktop) {
                setOpenSubMenu(false);
            }
        };
        window.addEventListener('mousedown', handleMouseLeave);
        return () => {
            window.removeEventListener('mousedown', handleMouseLeave);
        };
    }, [menuButton, openSubMenu, profileButton, setOpenSubMenu, wrapperRef]);
};
